import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { finalizeLoader, GuiFacade } from '@app/store/gui';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { priceActions } from '../actions/price.actions';
import { HttpService } from '../services/http.service';

@Injectable()
export class PriceEffects {
    private readonly actions$ = inject(Actions);
    private readonly guiFacade = inject(GuiFacade);
    private readonly httpService = inject(HttpService);

    getChainPrice$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(priceActions.getChainPrice),
            switchMap(({ id }) =>
                this.httpService.getChainPrices(id).pipe(
                    map((payload) => priceActions.getChainPriceSuccess({ payload })),
                    catchError((error: HttpErrorResponse) => of(priceActions.getChainPriceError({ code: error.status }))),
                    finalizeLoader(this.guiFacade, 'price-chain-get'),
                ),
            ),
        );
    });

    getStorePrice$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(priceActions.getStorePrice),
            switchMap(({ id }) =>
                this.httpService.getStorePrices(id).pipe(
                    map((payload) => priceActions.getStorePriceSuccess({ payload })),
                    catchError((error: HttpErrorResponse) => of(priceActions.getStorePriceError({ code: error.status }))),
                    finalizeLoader(this.guiFacade, 'price-store-get'),
                ),
            ),
        );
    });

    getExchangeRates$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(priceActions.getExchangeRates),
            switchMap(() =>
                this.httpService.getExchangeRates().pipe(
                    map((payload) => priceActions.getExchangeRatesSuccess({ payload })),
                    catchError((error: HttpErrorResponse) => of(priceActions.getExchangeRatesError({ code: error.status }))),
                    finalizeLoader(this.guiFacade, 'price-exchange-rates-get'),
                ),
            ),
        );
    });
}
